const ACTIONS = {
  GET_PARTNERSHIP: "getPartnership",
  UPGRADE: "upgrade",
  CANCEL: "cancel",
  AUTO_RENEWAL_ON: "auto_renewal_on",
  GET_ALL_BUSINESS_PARTNERS: "getAllBusinessPartners",
};

export { ACTIONS };
